import { useEffect, useState } from 'react'
import FileUpload from '../../../Objects/FileUpload/FileUpload'
import { ConnectDatasource } from './ConnectDatasource/ConnectDatasource'
import { EmailForward } from './EmailForward/EmailForward'
import BlendingDatasets from './Blending/BlendingDatasets'
import { EVENTS, trackEvent } from '../../../../events'
import { CreateDatasetModal } from './CreateDatasetModal/CreateDatasetModal'
import { AIFlow } from './AIFlow/AIFlow'

export const NewDatasetModal = ({
    open,
    onClose,
    getMetadata,
    openBlendedDataset,
    workspaceMetadata,
}) => {
    const [step, setStep] = useState(0)
    const [selectedSource, setSelectedSource] = useState('')
    const [option, setOption] = useState('')
    const [createdInbox, setCreatedInbox] = useState('')

    const handleSelectSource = (option, optionalSource) => {
        setStep(1)
        setOption(option)
        if (optionalSource) setSelectedSource(optionalSource)
    }

    useEffect(() => {
        if (openBlendedDataset) {
            setStep(1)
            setOption('Existing Scoop Data')
        }
    }, [openBlendedDataset])

    const renderStepContent = () => {
        if (open)
            switch (step) {
                case 0:
                    return (
                        <CreateDatasetModal
                            open={true}
                            handleSelectSource={handleSelectSource}
                            close={() => {
                                onClose()
                                setStep(0)
                            }}
                            workspaceMetadata={workspaceMetadata}
                        />
                    )
                case 1:
                    return renderStep2()
                case 2:
                    return (
                        <AIFlow
                            inboxID={createdInbox}
                            goBack={() => setStep(1)}
                            onClose={() => {
                                onClose()
                                setStep(0)
                            }}
                        />
                    )
                default:
                    return renderStepContent()
            }
        else return <></>
    }

    const renderStep2 = () => {
        if (open) {
            switch (option) {
                case 'File Upload':
                    return (
                        <FileUpload
                            isOpen={open}
                            onClose={() => {
                                onClose()
                                setStep(0)
                            }}
                            goNext={(inboxName) => {
                                getMetadata().then((res) => {
                                    const inboxID = res?.data?.inboxes?.find(
                                        (inbox) => inbox.label === inboxName
                                    )?.inboxID
                                    if (inboxID) setCreatedInbox(inboxID)
                                    trackEvent(EVENTS.DATASET.UPLOAD_COMPLETE, {
                                        file: { name: inboxName },
                                        inbox: { inboxID: inboxID },
                                    })
                                })
                                setStep(2)
                            }}
                            stepBack={() => setStep(0)}
                        />
                    )
                case 'Application':
                    return (
                        <ConnectDatasource
                            onClose={() => {
                                onClose()
                                setStep(0)
                            }}
                            stepBack={() => setStep(0)}
                            source={selectedSource.sourceValue}
                            sourceStep={selectedSource.step}
                            workspaceMetadata={workspaceMetadata}
                            goNext={(inboxName) => {
                                getMetadata().then((res) => {
                                    const inboxID = res?.data?.inboxes?.find(
                                        (inbox) => inbox.label === inboxName
                                    )?.inboxID
                                    if (inboxID) setCreatedInbox(inboxID)
                                })
                                setStep(2)
                            }}
                        />
                    )
                case 'Data Email':
                    return (
                        <EmailForward
                            onClose={() => {
                                onClose()
                                setStep(0)
                            }}
                            stepBack={() => setStep(0)}
                            getMetadata={getMetadata}
                            workspaceMetadata={workspaceMetadata}
                        />
                    )
                case 'Existing Scoop Data':
                    return (
                        <BlendingDatasets
                            onClose={() => {
                                onClose()
                                setStep(0)
                            }}
                            stepBack={() => onClose()}
                        />
                    )
                default:
                    return <> </>
            }
        }
    }

    return <>{renderStepContent()}</>
}
